import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const UserTypeSelector = ({ onSelect, isLoading = false }) => {
  const [selectedType, setSelectedType] = useState(null);

  const userTypes = [
    {
      type: 'user',
      title: 'کاربر عادی',
      description: 'دریافت مشاوره حقوقی از ربات هوشمند',
      icon: 'MessageSquare',
      color: 'bg-secondary',
      features: [
        'پرسش و پاسخ با ایران‌داد ',
        'راهنمایی‌های حقوقی فوری',
        'دسترسی به منابع حقوقی',
      ],
    },
    {
      type: 'lawyer',
      title: 'وکیل',
      description: 'مدیریت پروفایل حرفه‌ای و ارائه مشاوره',
      icon: 'Scale',
      color: 'bg-primary',
      features: [
        'ایجاد پروفایل حرفه‌ای',
        'مدیریت مشاوره‌های آنلاین',
        'داشبورد تخصصی وکیل',
      ],
    },
  ];

  const handleTypeSelect = (type) => {
    setSelectedType(type);
  };

  const handleContinue = () => {
    if (selectedType && onSelect) {
      onSelect(selectedType);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="space-y-6">
      <div className="text-center space-y-2">
        <h3 className="text-xl font-semibold text-foreground">
          نوع کاربری خود را انتخاب کنید
        </h3>
        <p className="text-sm text-muted-foreground">
          برای ادامه، لطفاً نوع حساب کاربری مورد نظر خود را مشخص کنید
        </p>
      </div>
      <div className="grid gap-4">
        {userTypes?.map((userType, index) => (
          <motion.div
            key={userType?.type}
            initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
            className={`relative p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 ${
              selectedType === userType?.type
                ? 'border-primary bg-primary/5 shadow-moderate'
                : 'border-border hover:border-primary/50 hover:shadow-subtle'
            }`}
            onClick={() => handleTypeSelect(userType?.type)}>
            {/* Selection Indicator */}
            {selectedType === userType?.type && (
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                className="absolute top-3 left-3 w-6 h-6 bg-primary rounded-full flex items-center justify-center">
                <Icon name="Check" size={14} color="white" />
              </motion.div>
            )}

            <div className="flex items-start space-x-reverse space-x-4">
              {/* Icon */}
              <div
                className={`w-12 h-12 ${userType?.color} rounded-lg flex items-center justify-center flex-shrink-0`}>
                <Icon name={userType?.icon} size={24} color="white" />
              </div>

              {/* Content */}
              <div className="flex-1 space-y-2">
                <div>
                  <h4 className="text-lg font-semibold text-foreground">
                    {userType?.title}
                  </h4>
                  <p className="text-sm text-muted-foreground">
                    {userType?.description}
                  </p>
                </div>

                {/* Features */}
                <ul className="space-y-1">
                  {userType?.features?.map((feature, featureIndex) => (
                    <li
                      key={featureIndex}
                      className="flex items-center text-xs text-muted-foreground">
                      <Icon
                        name="Check"
                        size={14}
                        className="ml-2 text-success flex-shrink-0"
                      />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
      {/* Continue Button */}
      <div className="pt-4">
        <Button
          variant="default"
          size="lg"
          onClick={handleContinue}
          disabled={!selectedType}
          loading={isLoading}
          fullWidth
          iconName="ArrowLeft"
          iconPosition="left">
          {isLoading ? 'در حال ورود...' : 'ادامه'}
        </Button>

        {selectedType && (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-xs text-muted-foreground text-center mt-2">
            شما به عنوان{' '}
            {userTypes?.find((t) => t?.type === selectedType)?.title} وارد
            خواهید شد
          </motion.p>
        )}
      </div>
    </motion.div>
  );
};

export default UserTypeSelector;
